import { render } from "./HomePageFeaturedProducts.vue?vue&type=template&id=ff6e4556&scoped=true"
import script from "./HomePageFeaturedProducts.vue?vue&type=script&lang=js"
export * from "./HomePageFeaturedProducts.vue?vue&type=script&lang=js"

import "./HomePageFeaturedProducts.vue?vue&type=style&index=0&id=ff6e4556&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6e4556"]])

export default __exports__